import { type AgGridReact } from "@jsq/ds/core";
import { getRowStyle } from "./rowHelpers";

export const gridOptions: AgGridReact.AgGridReactProps["gridOptions"] = {
  autoSizeStrategy: {
    type: "fitGridWidth",
  },
  suppressCellFocus: true,
  rowHeight: 61,
  domLayout: "normal",
  rowModelType: "serverSide",
  statusBar: {
    statusPanels: [{ statusPanel: "agTotalRowCountComponent" }],
  },
  defaultColDef: {
    resizable: true,
    sortable: false,
    filter: false,
    suppressHeaderMenuButton: true,
  },
  pagination: true,
  paginationPageSize: 25,
  paginationPageSizeSelector: [25, 50, 100],
  cacheBlockSize: 25,
  suppressMovableColumns: true,
  suppressColumnMoveAnimation: true,
  suppressRowHoverHighlight: true,
  suppressContextMenu: true,
  getRowStyle,
};
